export enum AssetType { SCRIPTS, STYLES }
